// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"825b3b14","175":"8a3db624","195":"768ba585","269":"7e467ce5","453":"19405918","764":"0c2de214"}[chunkId] + ".chunk.js";
};